import Radio from '.././../util/radio';
import OopsOverlayMessages from './i18n/OopsOverlayMessages';
import ModalDialog from '../../util/ModalDialog';

class OopsOverlayView {
  constructor(options = { error: {} }) {
    const { message, urlTitle, url } = options.error || {};

    this.template = options.template;
    this.data = {
      i18n: OopsOverlayMessages,
      errorMessage: message,
      urlTitle,
      url,
    };
  }

  async render() {
    const speedBumpOverlayRadio = Radio.channel('speedBumpOverlay');
    // Remove parent view when OopsOverlayView renders so there is no overlap in overlays
    speedBumpOverlayRadio.trigger('remove');
    this.overlay = new ModalDialog({
      id: 'oops-overlay',
      destroyOnClose: true,
      content: this.template(this.data),
    });
    await this.overlay.open();
    return this;
  }
}

export default OopsOverlayView;
